import React, { useState } from 'react';
import { motion } from 'framer-motion';

const TechRoles = ({ title, description, roleGroups = [] }) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <section 
      className="py-24 px-6 md:px-12 relative overflow-hidden" 
      style={{ backgroundColor: '#001534', color: '#ffffff' }}
    >
      <div className="max-w-[1240px] mx-auto relative z-10">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-5 text-white">
            {title}
          </h2>
          <p 
            className="max-w-[640px] mx-auto text-base md:text-lg leading-relaxed"
            style={{ color: '#94a3b8' }}
          >
            {description}
          </p>
        </motion.div>

        {/* Roles Column Architecture (No Cards) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mt-10">
          {roleGroups.map((group, gIndex) => (
            <div key={gIndex} className="flex flex-col">
              <h3 
                className="text-lg font-bold pb-4 mb-5 uppercase tracking-wider text-left border-b-2"
                style={{ color: '#00c6ff', borderBottomColor: 'rgba(0, 198, 255, 0.2)' }}
              >
                {group.title}
              </h3>
              <div className="flex flex-col gap-3">
                {group.items.map((role, rIndex) => {
                  const itemId = `${gIndex}-${rIndex}`;
                  return (
                    <motion.div
                      key={rIndex}
                      className="flex items-center gap-3 py-3 px-3.5 rounded-lg border-b transition-all duration-300 cursor-default hover:pl-5"
                      style={{
                        borderBottomColor: hoveredItem === itemId ? 'rgba(0, 198, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                        backgroundColor: hoveredItem === itemId ? 'rgba(255, 255, 255, 0.03)' : 'transparent'
                      }}
                      onMouseEnter={() => setHoveredItem(itemId)}
                      onMouseLeave={() => setHoveredItem(null)}
                      initial={{ opacity: 0, y: 15 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: (gIndex * 4 + rIndex) * 0.05 }}
                      viewport={{ once: true }}
                    >
                      <span className="text-lg">{role.icon}</span>
                      <p 
                        className="text-[15px] font-semibold text-left m-0"
                        style={{ color: hoveredItem === itemId ? '#00c6ff' : '#ffffff' }}
                      >
                        {role.name}
                      </p>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechRoles;
